import React from "react";

// Official RISE your LIFE mark: ocra sun + magenta heartbeat.
export function RiseLogo({ className = "", width = 40, height = 26 }) {
  return (
    <svg
      viewBox="0 0 64 42"
      width={width}
      height={height}
      className={className}
      role="img"
      aria-label="RISE your LIFE"
      data-testid="rise-logo"
    >
      <path d="M8 33 A24 24 0 0 1 56 33 Z" fill="#E08A3C" />
      <polyline
        points="0,33 15,33 21,20 26,40 32,9 38,33 64,33"
        fill="none"
        stroke="#C81D6B"
        strokeWidth="3.4"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
